import ProjectCard from "./ProjectCard";

export default function Portfolio() {
  return (
    <section className="py-20 bg-gray-100 px-6">
      <h2 className="text-4xl font-extrabold text-center text-gray-900 mb-10">
        Some of my work
      </h2>
      <p className="text-lg text-gray-600 text-center max-w-3xl mx-auto mb-12">
        Below are some of the projects I have created or contributed to, showcasing my skills in product management, innovation, and technology development.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
        <ProjectCard
          image="/braveready.png"
          title="Brave Ready"
          description="A career discovery feature for military, veterans, and families to help them find their next career using OpenAI's API."
          linkHref="https://braveready.org"
        />
        <ProjectCard
          image="/onwardops.png"
          title="Onward Ops"
          description="A full-stack web applicaiton develope duisng Laravel & React, providing a comprehensive resource and tools."
          linkHref="https://onwardops.org"
        />
        <ProjectCard
          image="/digitalsaber.png"
          title="Digital Saber"
          description="A platform of digital services that provide high-touch, high impact solutions for businesses and organizations."
          linkHref="https://digitalsaber.io"
        />
        <ProjectCard
          image="/saberalert.png"
          title="Saber Alert"
          description="A real-time threat detection and alert system leveraging AI and machine learning for increased situational awareness."
          linkHref="https://saberalert.com"
        />
        <ProjectCard
          image="/baxterbuilt.png"
          title="Baxter Built"
          description="A home improvement and contracting service in Texas, focused on delivering high-quality custom builds and renovations."
          linkHref="https://baxterbuilttx.com"
        />
        <ProjectCard
          image="/popgainz.png"
          title="Pop Gainz"
          description="A high-protein, low-calorie popcorn product aimed at fitness enthusiasts looking for a delicious, healthy snack!"
        />
      </div>
    </section>
  );
}
